import * as React from 'react'
import styled from 'styled-components'
import * as api from '@owl-nest/api-client/next'

import { t, tc } from '@owl-nest/localize'
import * as hooks from '@owl-nest/hooks'
import * as models from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'

type SuccessFreeSubscriptionModalProps = { project: api.Project }

export function SuccessFreeSubscriptionModal({ project }: SuccessFreeSubscriptionModalProps): React.ReactElement {
  const [isModalOpen, setIsModalOpen] = hooks.useModal('SuccessFreeSubscription')

  return (
    <ModalWithPastille
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      closable
      pastille={
        <plume.Pastille>
          <plume.illustrations.twoToned.HeartWithConfetti size={80} inverted noBackground />
        </plume.Pastille>
      }
    >
      <plume.styles.heading.S>{t('Welcome!')}</plume.styles.heading.S>
      <plume.styles.copy.M>
        {tc(
          'You are now part of the [strong: %(projectOwner)s] community. You will be notified of all free posts.',
          {
            strong: <strong />,
            projectOwner: models.project.name(project),
          },
        )}
      </plume.styles.copy.M>
      <plume.ButtonAsLink onClick={() => setIsModalOpen(false)} href={project.absolute_url}>
        {t('Go to page')}
      </plume.ButtonAsLink>
    </ModalWithPastille>
  )
}

const ModalWithPastille = styled(plume.ModalWithPastille)`
  ${plume.styles.image.Pastille} {
    background-color: ${plume.COLORS.SECONDARY_GREEN_800};
  }

  ${plume.ButtonAsLink} {
    margin-top: 24px;
    width: 100%;

    ${plume.styles.button.Base} {
      width: 100%;
    }
  }

  ${plume.styles.copy.M} {
    margin-top: 10px;
  }
`
